import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  ErrorMessagesInterface,
  Values,
} from '@modules/select/interfaces/select';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit {
  public disabledSelect: boolean = false;

  @Input() control = new FormControl(null);
  @Input() idSelect: string = uuidv4();
  @Input() placeholder: string = '';
  @Input() label: string | null = null;
  @Input() errorMessages: ErrorMessagesInterface = {};
  @Input() successMessage: string | null = null;
  @Input() textCaption: string | null = null;
  @Input() values: Values[] = [];
  @Input() multiple: boolean = false;
  @Input() set disabled(value: boolean) {
    this.disabledSelect = value;
  }

  public defaultErrors: ErrorMessagesInterface = {
    required: 'Este campo es obligatorio',
  };

  ngOnInit(): void {
    this.errorMessages = { ...this.defaultErrors, ...this.errorMessages };
  }

  displayError(errors: {}) {
    return this.errorMessages[Object.keys(errors)[0]];
  }

  clickMatSelect(event: any) {
    const matSelect: HTMLElement = this.getNextSibling(
      event.target,
      '.mat-mdc-select'
    );
    const trigger: HTMLElement = matSelect.querySelector(
      '.mat-mdc-select-trigger'
    ) as HTMLElement;
    trigger.click();
  }

  getNextSibling(elem, selector?) {
    let sibling = elem.nextElementSibling;
    if (!selector) return sibling;
    while (sibling) {
      if (sibling.matches(selector)) return sibling;
      sibling = sibling.nextElementSibling;
    }
  }
}
